export default "./images/WDInfoNoCompassFix2.jpg";